import * as THREE from 'three'
import Sizes from './Utils/Sizes.js'
import Time from './Utils/Time.js'
import Mouse from './Utils/Mouse.js'
import Resources from './Utils/Resources.js'
import Debug from './Utils/Debug.js'
import Camera from './Camera.js'
import Renderer from './Renderer.js'
import World from './World/World.js'
import sources from './sources.js'

let instance = null

/**
 * Experience
 * Singleton root class. Receives the canvas element and bootstraps every subsystem.
 * Owns the Three.js Scene and coordinates the update/resize propagation chain.
 *
 * Access from any child class:
 *   this.experience = new Experience()
 *   this.scene      = this.experience.scene
 *   this.sizes      = this.experience.sizes
 *   this.time       = this.experience.time       // .elapsed (ms), .delta (ms)
 *   this.mouse      = this.experience.mouse      // .current.x/y (0..1, lerped)
 *   this.resources  = this.experience.resources  // .items['name']
 *   this.debug      = this.experience.debug      // .active, .ui (lil-gui)
 */
export default class Experience {
    constructor(canvas) {
        // Singleton — subsequent calls return the cached instance
        if (instance) return instance
        instance = this

        this.canvas = canvas
        this.scene  = new THREE.Scene()

        // Order matters: Debug and Sizes must be first; Mouse needs Sizes + Time
        this.debug     = new Debug()
        this.sizes     = new Sizes()
        this.time      = new Time()
        this.mouse     = new Mouse()
        this.resources = new Resources(sources)
        this.camera    = new Camera()
        this.renderer  = new Renderer()
        this.world     = new World()

        this.sizes.on('resize', () => this.resize())
        this.time.on('tick',   () => this.update())
    }

    resize() {
        this.camera.resize()
        this.renderer.resize()
    }

    update() {
        this.camera.update()
        this.world.update()
        this.renderer.update()
    }
}
